export default {"src":"/_next/static/media/search.958c3e2d.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};